module.exports = __webpack_public_path__ + "static/img/12.1549da1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/12.png
// module id = KI8i
// module chunks = 0